import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom'
import './style.css'
import { useDispatch } from 'react-redux'
import { Signup } from '../../../commons/redux/actions/auth.action'
import { Button, useToast } from '@chakra-ui/react'

export default function Create() {
  const dispatch = useDispatch()
  const toast = useToast()
  const [load, setLoad] = useState(false)
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [err, setErr] = useState()

  async function createUser(values) {
    console.log(values);
    try {
      setLoad(true)
      const {res,err} = await dispatch(Signup(values))
      if (res.response.status === 409) {
        setErr("L'utilisateur existe")
        toast({
          title: 'Conflit.',
          description: 'Cet utilisateur existe !!',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        console.log(err)
        setLoad(false)
      }
      setLoad(false)
    } catch (error) {
      console.log(error)
      setLoad(false)
    }
  }
  useEffect(() => {
    if (typeof window !== 'undefined' && token) {
      toast({
        title: 'Bravo',
        description: 'Votre compte a ete cree',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      window.location.href = '/'
    }
  }, [navigate, token, toast])
  const formik = useFormik({
    initialValues: {
      name: '',
      tel: '',
      district: '',
      email: '',
      town: '',
      password: '',
    },
    onSubmit: async (values) => {
      try {
        setLoad(true)
        createUser(values)
      } catch (error) {
        setLoad(false)
      }
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Mettez un email valide')
        .lowercase()
        .required('Ce champ est requis'),
      name: Yup.string()
        .required('Ce champ est requis !')
        .min(4, 'Au moins 4 caracteres')
        .max(20, 'Trop de characteres'),
      password: Yup.string()
        .required('Ce champ est requis !')
        .min(4, 'Il faut au moins 4 caracteres'),
      tel: Yup.string().trim("Pas d'espace").required('Ce champ est requis !'),
    }),
  })
  return (
    <div>
      <div className="container flex-c">
        <div className="form mx-auto p-2 mt-3 my-2">
          <div className="title_sign text-center">
            <h3>Ouvrir un compte</h3>
            <p className="text-muted text-sm">
              Veuillez remplir le formulaire suivant pour creer votre compte
              pour profiter de nos fonctionnalites
            </p>
          </div>
          {err ? (
            <div
              class="bg-red-100 my-2 border-l-8 border-red-400 text-red-700 px-4 py-3 rounded relative"
              role="alert"
            >
              <span class="block font-bold sm:inline">{err}</span>
              <span
                onClick={() => setErr('')}
                class="absolute top-0 bottom-0 right-0 px-4 py-3"
              >
                <svg
                  class="fill-current h-6 w-6 text-red-500"
                  role="button"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <title>Close</title>
                  <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                </svg>
              </span>
            </div>
          ) : (
            ''
          )}
          <form autoComplete={'false'}>
            <div className="form-group">
              <label htmlFor="" className="sr-only">
                Nom
              </label>
              <input
                type="tex"
                name="name"
                placeholder="Nom"
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
              />
              <small className="helper-text form-tex text-red-500">
                {formik.touched.name && formik.errors.name}
              </small>
            </div>

            <div className="form-group mt-2">
              <label htmlFor="" className="sr-only">
                Contact
              </label>
              <input
                type="text"
                name="tel"
                placeholder="Telephone"
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                value={formik.values.tel}
                onChange={formik.handleChange}
                error={formik.touched.tel && Boolean(formik.errors.tel)}
              />
              <small className="helper-text form-tex text-red-500">
                {formik.touched.tel && formik.errors.tel}
              </small>
            </div>
            <div className="form-group mt-2">
              <label htmlFor="" className="sr-only">
                Email
              </label>
              <input
                type="text"
                name="email"
                placeholder="Email"
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
              />
              <small className="helper-text form-tex text-red-500">
                {formik.touched.email && formik.errors.email}
              </small>
            </div>
            <div className="flex">
              <div className="form-group mt-2 mx-1">
                <label htmlFor="" className="sr-only">
                  Ville
                </label>
                <input
                  type="text"
                  name="town"
                  placeholder="Ville"
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  value={formik.values.town}
                  onChange={formik.handleChange}
                  error={formik.touched.town && Boolean(formik.errors.town)}
                />
                <small className="helper-text form-tex text-red-500">
                  {formik.touched.town && formik.errors.town}
                </small>
              </div>

              <div className="form-group mt-2">
                <label htmlFor="district" className="sr-only">
                  Quartier
                </label>
                <input
                  type="text"
                  name="district"
                  placeholder="Quartier"
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  value={formik.values.district}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.district && Boolean(formik.errors.district)
                  }
                />
                <small className="helper-text form-tex text-red-500">
                  {formik.touched.district && formik.errors.district}
                </small>
              </div>
            </div>

            <div className="form-group mt-2">
              <label htmlFor="" className="sr-only">
                Mot de passe
              </label>
              <input
                type="password"
                name="password"
                placeholder="Mot de passe"
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
              />
              <small className="helper-text form-tex text-red-500">
                {formik.touched.password && formik.errors.password}
              </small>
            </div>
            <div className="my-3">
              <input
                type="checkbox"
                className="hover:cursor-pointer p-1 mt-2 bg-gray-100 rounded text-red text-sm"
                name="accept"
                id="accept"
              />
              <label className="mx-1 text-md">
                J'accepte les{' '}
                <a href="/condition" className="text-orange-500">
                  Conditions d'utilisations
                </a>
              </label>
            </div>
            <div className="flex-col">
              {load ? (
                <Button
                  isLoading={true}
                  loadingText={'Ouverture...'}
                  variant={'outline'}
                  colorScheme={'orange'}
                  className="btn btn-block w-100  bg-gray-300 my-2 font-bold text-xl"
                >
                  Creer mon compte{' '}
                </Button>
              ) : (
                <button
                  type="button"
                  onClick={formik.handleSubmit}
                  className="btn btn-block my-2 w-100 hover:text-white bg-orange-500 border-none my-2 hover:bg-orange-600  text-xl"
                >
                  Creer mon compte{' '}
                </button>
              )}
            </div>
          </form>
          <div className="mx-auto text-center flex-col mt-2 justify-content-center">
            <p className="text-md text-muted">Vous etes deja inscris ?</p>
            <a
              href="/se-connecter"
              className=" border p-1 mt-2 bg-gray-100 rounded text-red text-sm"
            >
              Connectez-vous
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
